import React, { useEffect, useRef, useState } from 'react';

// Defers mounting until the placeholder is near the viewport. The lead sheet
// tab shows 20 cards at once, and each roll otherwise fetches its notes and
// starts a requestAnimationFrame loop immediately on mount.
const LazyMount = ({ children, minHeight = 120, rootMargin = '300px' }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(typeof IntersectionObserver === 'undefined');

  useEffect(() => {
    if (visible) return undefined;

    const el = ref.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setVisible(true);
        observer.disconnect();
      }
    }, { rootMargin });

    observer.observe(el);
    return () => observer.disconnect();
  }, [visible, rootMargin]);

  if (visible) return children;

  return <div ref={ref} className="piano-roll-loading" style={{ minHeight }} />;
};

export default LazyMount;
